import { render } from "./MyContributions.vue?vue&type=template&id=5ee3721a&ts=true"
import script from "./MyContributions.vue?vue&type=script&lang=ts"
export * from "./MyContributions.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__